var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0017 27.1111C22.1382 27.1111 27.1128 22.1365 27.1128 16C27.1128 9.86353 22.1382 4.88892 16.0017 4.88892C9.86524 4.88892 4.89062 9.86353 4.89062 16C4.89062 22.1365 9.86524 27.1111 16.0017 27.1111Z",
    stroke: "url(#paint0_linear_471_720)",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.5555V20.4444",
    stroke: "url(#paint1_linear_471_720)",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5586 16H20.4475",
    stroke: "url(#paint2_linear_471_720)",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_471_720",
    x1: 4.89063,
    y1: 16,
    x2: 27.1128,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#097EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AAB6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_471_720",
    x1: 16,
    y1: 16,
    x2: 17,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#097EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AAB6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_471_720",
    x1: 11.5586,
    y1: 16.5,
    x2: 20.4475,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#097EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AAB6C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.5f4f62da.svg";
export { ForwardRef as ReactComponent };